import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';

@Component({
  selector: 'app-DeviceBehfaActiveList',
  templateUrl: './DeviceBehfaActiveList.component.html',
  styleUrls: ['./DeviceBehfaActiveList.component.scss']
})
export class DeviceBehfaActiveListComponent implements OnInit {

  @Input() inner_PersianDate:string=''
  @Input() inner_Filter:boolean=false
  @Input() inner_SeletedDeviceBehfa: Array<DeviceBehfa_Interface> = []
  @Input() inner_MultiSelectTools:boolean=false

  @Output() seleted_DeviceBehfa_Interface = new EventEmitter<DeviceBehfa_Interface>();

  page:number=0
  constructor(
    private DeviceBehfa_Service: DeviceBehfaService,
    private DeviceGroup_Service:DeviceGroupService,
  ) { }

  ngOnInit() {

    this.Read_First_Device_Group()
  }

  Procssing_DeviceBehfa: boolean = false

  Search_Code_DeviceBehfa_Table: string = ''


  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []

  ReadData_DeviceBehfa_KeySearch_Timer: any
  ReadData_DeviceBehfa_KeySearch() {

    if (this.ReadData_DeviceBehfa_KeySearch_Timer) {
      clearTimeout(this.ReadData_DeviceBehfa_KeySearch_Timer);
      this.ReadData_DeviceBehfa_KeySearch_Timer = null;
    }

    this.ReadData_DeviceBehfa_KeySearch_Timer = setTimeout(function () {
      this.ReadData_DeviceBehfa()
    }.bind(this), 1000);

  }

  ReadData_DeviceBehfa() {
    this.Procssing_DeviceBehfa = true
    this.DataList_DeviceBehfa = []

    this.DeviceBehfa_Service.GetSearchBehfaDeviceActive(this.Search_Code_DeviceBehfa_Table,
      this.inner_PersianDate,
      this.inner_Filter,
      Number(this.First_Device_Group_Selected),
      Number(this.Second_Device_Group_Selected)).subscribe(
        data => {

          this.DataList_DeviceBehfa = data
          this.Procssing_DeviceBehfa = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
  }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    this.seleted_DeviceBehfa_Interface.emit(item);
  }

  ToggleSelectedDevice(item: DeviceBehfa_Interface, selected: boolean) {
    const index = this.inner_SeletedDeviceBehfa.findIndex(detail => detail.id === item.id);
    if (selected && index < 0) {
      this.inner_SeletedDeviceBehfa.push(item);
      this.seleted_DeviceBehfa_Interface.emit(item);
    } else if (!selected && index >= 0) {
      this.inner_SeletedDeviceBehfa.splice(index, 1);
    }
  }

  SelectAllCurrentResults() {
    this.CurrentDisplayedResults.forEach(item => this.ToggleSelectedDevice(item, true));
  }

  DeselectCurrentResults() {
    const currentIds = new Set(this.CurrentDisplayedResults.map(item => item.id));
    for (let index = this.inner_SeletedDeviceBehfa.length - 1; index >= 0; index--) {
      if (currentIds.has(this.inner_SeletedDeviceBehfa[index].id)) {
        this.inner_SeletedDeviceBehfa.splice(index, 1);
      }
    }
  }

  ClearAllSelectedDevices() {
    this.inner_SeletedDeviceBehfa.splice(0, this.inner_SeletedDeviceBehfa.length);
  }

  ToggleAllCurrentResults(selected: boolean) {
    selected ? this.SelectAllCurrentResults() : this.DeselectCurrentResults();
  }

  get AllCurrentResultsSelected(): boolean {
    return this.CurrentDisplayedResults.length > 0 && this.CurrentDisplayedResults.every(item => this.Check_InList(item));
  }

  get SomeCurrentResultsSelected(): boolean {
    const count = this.CurrentDisplayedResults.filter(item => this.Check_InList(item)).length;
    return count > 0 && count < this.CurrentDisplayedResults.length;
  }

  get CurrentDisplayedResults(): DeviceBehfa_Interface[] {
    const currentPage = Math.max(Number(this.page) || 1, 1);
    const start = (currentPage - 1) * 50;
    return this.DataList_DeviceBehfa.slice(start, start + 50);
  }

  Check_InList(item:DeviceBehfa_Interface)
  {
    for(let detail of this.inner_SeletedDeviceBehfa)
    {
      if(item.id==detail.id)
      {
        return true
      }
    }
    return false
  }


  //#region Device Group

  DataList_First_Device_Group:Array<General_Interface>=[]
  DataList_Second_Device_Group:Array<General_Interface>=[]

  First_Device_Group_Selected:string='0'
  Second_Device_Group_Selected:string='0'

  Read_First_Device_Group(){
    this.DeviceGroup_Service.GetDeviceGroup(0).subscribe(
      data=>{
        this.DataList_First_Device_Group=data
      }
    )
  }

  Read_Second_Device_Group(){
    this.Second_Device_Group_Selected="0"
    this.DeviceGroup_Service.GetDeviceGroup(Number(this.First_Device_Group_Selected)).subscribe(
      data=>{
        this.DataList_Second_Device_Group=data
      }
    )
  }

  //#endregion


}
